import { Box, Typography } from '@mui/material'
import { t } from '$i18n'

export function EmptyState() {
  return (
    <Box sx={{ width: '100%' }}>
      <Typography
        color="primary"
        variant="body2"
        sx={{ display: 'block', marginTop: '50px', textAlign: 'center' }}
      >
        {t('emptyState.noContentFound')}
      </Typography>
    </Box>
  )
}
